import React from "react";
import PageHeader from "../layout/PageHeader";

const AiHiringDisabled = (props) => {
  return (
    <div className="page-shell ai-hiring-page">
      <PageHeader
        title="AI Hiring"
        subtitle="This feature is not enabled for your agency yet."
        icon={
          <span role="img" aria-label="AI">
            🤖
          </span>
        }
        {...props}
      />
      <div className="ai-hiring-content">
        <div className="ai-card">
          <div className="ai-empty">
            Contact support to activate AI Hiring for your agency.
          </div>
        </div>
      </div>
    </div>
  );
};

export default AiHiringDisabled;
